import React, { Component } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap';
import CommonLoader from './loaderComponent/CommonLoader';

export default class VendorWorkOrderView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: this.props.location.state?.data.items || [],
      loading: true,
    };
  }

  async componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false })
    }, 600)
  }
  vendorWorkOrderList = () => {
    this.props.history.push('/vendor-work-order-list')
  }


  render() {
    console.log("VendorWorkOrderView props", this.props.location.state?.data);
    const { data } = this.props.location.state
    return (
      <>
        <CommonLoader isLoading={this.state.loading}>
          <div className="container-fluid pt-4">
            <Card>
              <Card.Header>
                <div className="purchase-order-back d-flex justify-content-between align-items-center">
                  <b>View Vendor Work Order</b>
                  <span style={{ cursor: 'pointer' }} onClick={() => this.vendorWorkOrderList()}>
                    <i className="far fa-arrow-alt-circle-right"> Vendor Work Order List</i>
                  </span>
                </div>
              </Card.Header>

              <Card.Body>
                <Row>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Vendor Name</Form.Label>
                      {
                        console.log("data", data)
                      }
                      <Form.Control type="text" value={data.vendor?.name} readOnly />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Customer Name</Form.Label>
                      <Form.Control type="text" value={data.customer?.name} readOnly />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Project Name</Form.Label>
                      <Form.Control type="text" value={data.project?.name} readOnly />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Purchase Order Number</Form.Label>
                      <Form.Control type="text" value={data.poNumber} readOnly />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>WO Number</Form.Label>
                      <Form.Control type="text" value={data.woNumber} readOnly />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>WO Date</Form.Label>
                      <Form.Control type="text" value={data.woDate} readOnly />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Dispatch Address</Form.Label>
                      <Form.Control type="text" value={data.dispatchAddress?.address} readOnly />
                    </Form.Group>
                  </Col>

                </Row>
                <hr />
                <h5>Items</h5>
                {
                  console.log("this.state?.data", this.state?.data)
                }
                {this.state?.data.map((item, index) => (
                  <div key={index} className="border p-3 mb-3 rounded bg-light">
                    {
                      console.log("item---->", item)
                    }
                    <Row>
                      <Col md={2}>
                        <Form.Group>
                          <Form.Label>S.No</Form.Label>
                          <Form.Control type="text" value={item.serialNumber || item.item?.serialNumber || ''} readOnly />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label>Item Name</Form.Label>
                          <Form.Control type="text" value={item.itemName || item.item?.name || ''} readOnly />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label>HSN Code</Form.Label>
                          <Form.Control type="text" value={item.hsnCode || item.item?.hsnCode || ''} readOnly />
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                        <Form.Group>
                          <Form.Label>UOM</Form.Label>
                          <Form.Control type="text" value={item.uom || item.item?.uom || ''} readOnly />
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                        <Form.Group>
                          <Form.Label>Quantity</Form.Label>
                          <Form.Control type="text" value={item.quantity} readOnly />
                        </Form.Group>
                      </Col>

                    </Row>
                    <Row>
                      <Col md={2}>
                        <Form.Group>
                          <Form.Label>Price</Form.Label>
                          <Form.Control type="text" value={item.price || item.price || ''} readOnly />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label>Asked Quantity</Form.Label>
                          <Form.Control type="text" value={item.askedQuantity || item.askedQuantity || ''} readOnly />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label>Taxable Value</Form.Label>
                          <Form.Control type="text" value={item.taxableValue || item.taxableValue || ''} readOnly />
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                        <Form.Group>
                          <Form.Label>GST (18%)</Form.Label>
                          <Form.Control type="text" value={item.gstValue || item.gstValue || ''} readOnly />
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                        <Form.Group>
                          <Form.Label>Total Value</Form.Label>
                          <Form.Control type="text" value={item.totalValue || item.totalValue || ''} readOnly />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                ))}
              </Card.Body>
            </Card>

          </div>
        </CommonLoader>
      </>
    )
  }
}
